import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sm-homeqrnot-available',
  templateUrl: './homeqrnot-available.component.html',
  styleUrls: ['./homeqrnot-available.component.scss']
})
export class HomeqrnotAvailableComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
